import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {
    get as _get
} from 'lodash';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../components/displaycard';

import Auth from '../../data/auth-service';
import DataContext from '../../data/data-context';
import Permissions from '../../data/permissions';

const { BRICATA_APPLIANCE_TYPE } = process.env;

const options = [
    {
        title: 'Alerts',
        description: 'View Suricata, Malware, and Zeek alerts generated by the sensors',
        img: '/images/alerts.png',
        route: 'alerts',
        perm: { Alerts: [...Permissions.Views.Alerts] },
    },
    {
        title: 'Anomalies',
        description: 'View Anomalies',
        img: '/images/analytics.png',
        route: 'anomalies',
        perm: { Anomalies: [...Permissions.Views.Anomalies] },
        app: 'cmc',
    },
    {
        title: 'Metadata',
        description: 'View Zeek metadata generated by the sensors',
        img: '/images/metadata.png',
        route: 'metadata',
        perm: { Metadata: [...Permissions.Views.Metadata] },
    },
    {
        title: 'Incident Response',
        description: 'Incident response workflow for investigations',
        img: '/images/incident-response.png',
        route: 'incident_response',
        perm: { Incidents: [...Permissions.Views.Incidents] },
        app: 'cmc',
    },
    {
        title: 'Packet Requests',
        description: 'Create a request for a PCAP download or download a previously requested PCAP',
        img: '/images/packet-capture.png',
        route: 'packet_requests',
        perm: { Pcap: [...Permissions.Views.Pcap] },
    },
    {
        title: 'Backtesting',
        description: 'Create and run backtesting jobs',
        img: '/images/backtesting.png',
        route: 'backtesting',
        perm: { Backtesting: [...Permissions.Views.Backtesting] },
        app: 'cmc',
    }
];

const Views = () => {
    const { systemSettings } = useContext(DataContext);
    const [backtesting, setBacktesting] = useState(false);

    useEffect(() => {
        setBacktesting(_get(systemSettings, 'support.backtesting.ui', false));
    }, [systemSettings]);

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {options.filter(option => (
                    !option.app || option.app === BRICATA_APPLIANCE_TYPE
                )).filter(o => Auth.perm(o.perm)).map((p, i) => {
                    if (!backtesting && p.title === 'Backtesting') {
                        return null;
                    }
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard aria-label={p} {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};
Views.propTypes = {
    perm: PropTypes.func,
};
export default Views;
